module.exports = __webpack_public_path__ + "img/gongzhonghaoerweima.9befe16c.png";